module.exports = __webpack_public_path__ + "static/img/cloud.9ff5334.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/cloud.jpg
// module id = VoES
// module chunks = 0